export enum FeatureFlagVariables {
  isBonusxUser = "is_bonusx_user",
  aiAssistantName = "ai_assistant_name",
  aiAssistantAnimatedIcon = "ai_assistant_animated_icon",
  freemiumModel = "freemium_model",
  freemiumModelReleaseDate = "freemium_model_release_date",
  freemiumFlexibleStructure = "freemium_flexible-structure",
  automaticDataExtraction = "automatic_data_extraction",
  testABPaywall = "test_ab_paywall",
  newPersonalDataOnboarding = "new_personal_data_onboarding",
  sophiaAssistant = "sophia_assistant",
}
